import { render } from "./ListItemComp.vue?vue&type=template&id=52bc3cd1"
import script from "./ListItemComp.vue?vue&type=script&lang=js"
export * from "./ListItemComp.vue?vue&type=script&lang=js"

import "./ListItemComp.vue?vue&type=style&index=0&id=52bc3cd1&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__